// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"eef08c93","152":"9d2bd1d2","281":"c0520318","453":"5caa5f0a","771":"051a89a9","825":"45d6f5de","887":"550288ff","992":"265d6814"}[chunkId] + ".chunk.js";
};